import React, { FC } from 'react';
import MapMarker from 'js/components/MapObjects/MapMarker';
import polygonSvgEdit from 'style/images/drawing/edit_location.svg';

interface MeasurementLine extends google.maps.Polyline {
  icon?: google.maps.Icon | { url: string };
}

interface SelectedMeasurementLineProps {
  line?: MeasurementLine | null;
}

const SelectedMeasurementLine: FC<SelectedMeasurementLineProps> = ({ line }) => {
  if (!line) return null;

  const path = line.getPath();
  if (path.getLength() < 2) return null;

  const latLng1 = path.getAt(0);
  const latLng2 = path.getAt(1);

  const midPosition: google.maps.LatLngLiteral = {
    lat: (latLng1.lat() + latLng2.lat()) / 2,
    lng: (latLng1.lng() + latLng2.lng()) / 2,
  };

  const icon: google.maps.Icon | { url: string } = line.icon || { url: polygonSvgEdit };

  return <MapMarker position={midPosition} icon={icon} />;
};

export default SelectedMeasurementLine;
